import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as projectDomain from '../../project-domain'

export const RESOURCE = {
  payload: {
    description: 'The association(s) between projects and domains',
    dimension: projectDomain.RESOURCE.payload,
    level: 0,
    name: 'Project Domain',
    partialId: PartialId.Standard.create('entry'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
